
/* WARNING: Do NOT remove the dayjs locale imports, otherwise the localizedFormat methods won't work. */
import "dayjs/locale/de-ch";
import "dayjs/locale/fr-ch";
import "dayjs/locale/it-ch";
import Button from "primevue/button";
import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import AccountModule from "@/store/modules/account";

@Component({ components: { Button } })
export default class LogoutButton extends Vue {
  private readonly accountState: AccountModule = getModule(AccountModule);
  private countdown: { display: string; datetime: string } = { display: "", datetime: "" };
  private accessibleCountdown: { display: string; datetime: string } = {
    display: "",
    datetime: "",
  };

  created() {
    if (this.accountState.remainingSessionTime) {
      this.setCountdown();
    }
  }

  @Watch("remainingSessionTime")
  onExpiresAtChange() {
    this.setCountdown();
  }

  @Emit("click")
  handleClick() {
    this.accountState.clearTimer();
  }

  get remainingSessionTime() {
    return this.accountState.remainingSessionTime;
  }

  setCountdown() {
    const datetime = this.accountState
      .remainingSessionTime!.locale(this.$i18n.locale)
      .format("[PT]m[M]s[S]");

    this.countdown = {
      display: this.accountState.remainingSessionTime!.locale(this.$i18n.locale).format("m:ss"),
      datetime,
    };

    this.accessibleCountdown = {
      display: this.accountState.remainingSessionTime!.locale(this.$i18n.locale).format("m"),
      datetime,
    };
  }
}
